import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import BarIcon from '@/assets/icons/bar-icon.svg';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledMarketShareBar = styled(Box)(() => ({
    width: '100%',
    padding: '4px',
    borderRadius: '4px',
    border: `2px solid ${Palette.gray.gray200}`,
    backgroundColor: Palette.white,
    position: 'relative',
    '& .progress-container': {
        width: '100%',
        height: '24px',
        backgroundColor: Palette.gray.gray100,
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url("${BarIcon}")`,
            backgroundRepeat: 'repeat-x',
            backgroundPosition: '-2px 0',
            zIndex: 1,
        },
    },
    '& .progress-bar': {
        height: '100%',
        backgroundColor: Palette.black,
        width: '2px',
    },
}));

const MarketShareBar = ({ record }) => {
    const marketShare = record.analytics.marketShare ?? 0;
    const marketSharePercentage = Number(marketShare * 100).toFixed(2);

    return (
        <StyledMarketShareBar>
            <Box className='progress-container'>
                <Box className='progress-bar' style={{ width: `${marketSharePercentage}%` }}></Box>
            </Box>
        </StyledMarketShareBar>
    );
};

export default MarketShareBar;
